

import _ from "lodash"
import React from "react"

const AddressOcrProblemsList = ({ inputData, validations, isInProspectView }) => {
  const renderNameValidation = () => {
    const { spouse_name, father_name, mother_name } = inputData
    if (!_.isEmpty(spouse_name)) {
      return `O nome do cônjuge, "${spouse_name}", não pôde ser identifcado no comprovante.`
    }
    if (!_.isEmpty(father_name)) {
      return `O nome do pai, "${father_name}", não pôde ser identifcado no comprovante.`
    }
    if (!_.isEmpty(mother_name)) {
      return `O nome da mãe, "${mother_name}", não pôde ser identifcado no comprovante.`
    }
    return isInProspectView
      ? 'O seu nome não pôde ser identificado no comprovante. O documento está mesmo em seu nome?'
      : 'O nome do assessor não pôde ser identificado no comprovante'
  }

  if (!validations) {
    return null
  }

  return (
    <ul>
      {!validations.bill_layout_valid && (
        <li>
          O arquivo enviado não aparenta ser um comprovante de residência, por exemplo, conta de luz, conta de
          água...
        </li>
      )}
      {(!validations.name_found_valid && !_.isEmpty(inputData)) && <li>{renderNameValidation()}</li>}
      {!validations.date_found && (
        <li>A data de emissão do comprovante não pôde ser identifacada.</li>
      )}
      {!validations.date_valid && <li>O comprovante aparenta ser muito antigo. {isInProspectView ? ' Envie outro mais recente.' : ''}</li>}
      {!validations.address_valid && <li>O endereço não pôde ser identificado no comprovante.</li>}
    </ul>
  )

}

export default AddressOcrProblemsList
